import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'

export function useZipCode() {
  const isLoading = ref(false)
  const { t } = useI18n()

  const searchAddressByZipCode = async (cep: string) => {
    const normalized = cep.replace(/\D/g, '')
    if (normalized.length !== 8) return

    try {
      isLoading.value = true
      const response = await fetch(`/api/v1/cep/search/${normalized}`)

      if (!response.ok) throw new Error()

      const data = await response.json()

      return {
        street: data.logradouro || '',
        district: data.bairro || '',
        city: data.localidade || '',
        region_code: data.uf || '',
        state: data.uf || '',
        country: 'Brasil',
      }
    } catch (_e) {
      toast.warning(t('CEP not found'))
      return null
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    searchAddressByZipCode,
  }
}
